import CheckoutPurchaseNew from "../screen/purchase/checkout/CheckoutPurchaseNew";
import PageTemplate from "../components/common/PageTemplate";

const CheckoutPurchasePage = () => {
  return (
    <PageTemplate
      mainComponent={<CheckoutPurchaseNew />}
      noPadding={true}
      logo="Checkout"
    />
  );
};

export default CheckoutPurchasePage;
